/**
 * Inject GymStack styles into Section Store Stack & Save shadow roots.
 */
(function () {
  var script = document.getElementById('gs-bundle-js') || document.currentScript;
  var cssUrl = script && script.getAttribute('data-css');
  var STYLE_ID = 'gs-bundle-theme';
  var cssText = '';
  var waiting = [];

  function inject(el) {
    if (!el || el.tagName !== 'SECTION-STORE--BUNDLE-BLOCK') return;
    var tryOnce = function () {
      var root = el.shadowRoot;
      if (!root || !cssText) return false;
      if (root.getElementById(STYLE_ID)) return true;
      var style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = cssText;
      root.appendChild(style);
      return true;
    };
    if (tryOnce()) return;
    waiting.push(el);
    var obs = new MutationObserver(function () {
      if (tryOnce()) obs.disconnect();
    });
    obs.observe(el, { childList: true, subtree: true });
    setTimeout(function () {
      obs.disconnect();
    }, 8000);
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.tagName === 'SECTION-STORE--BUNDLE-BLOCK') inject(root);
    root.querySelectorAll('section-store--bundle-block').forEach(inject);
  }

  function flushWaiting() {
    waiting.splice(0).forEach(inject);
    scan(document);
  }

  if (cssUrl) {
    fetch(cssUrl)
      .then(function (res) {
        return res.text();
      })
      .then(function (text) {
        cssText = text;
        flushWaiting();
      })
      .catch(function () {});
  }

  scan(document);
  if (!document.querySelector('section-store--bundle-block')) {
    var rootObs = new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) scan(node);
        });
      });
      if (document.querySelector('section-store--bundle-block')) {
        rootObs.disconnect();
      }
    });
    rootObs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () {
      rootObs.disconnect();
    }, 8000);
  }
})();
